
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { StatusBadgeStatus } from '@/core/enums/status-badge-status';

const TEST_ID = 'Kloans-StatusBadge';

@Component
export default class StatusBadge extends Vue {
	@Prop({ default: StatusBadgeStatus.INFO })
	public status!: StatusBadgeStatus;

	public TEST_ID = TEST_ID;

	get elementClass(): string {
		if (this.status === StatusBadgeStatus.SUCCESS) {
			return 'is-success';
		}

		if (this.status === StatusBadgeStatus.ERROR) {
			return 'is-error';
		}

		return 'is-info';
	}
}
